var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InstancesListTemplate',{attrs:{"list":_vm.section.free_counts,"count":_vm.section.free_count},scopedSlots:_vm._u([(_vm.section?.number)?{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t("titles.Section"))+" "),_vm._v(" "+_vm._s(_vm.section?.number)+" ")]},proxy:true}:null],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }